import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-guest-match-header",
  templateUrl: "./guest-match-header.component.html",
  styleUrls: ["./guest-flow.component.css"],
  standalone: false
})
export class GuestMatchHeaderComponent {
  @Input() public title = "";
  @Input() public titleClickable = false;
  @Input() public showBack = false;
  @Input() public backLabel = "";

  @Output() public back = new EventEmitter<void>();
  @Output() public titleClick = new EventEmitter<void>();
}
